import { loginRequest } from '../AuthConfig';
import { useOrganisationContext } from './useOrganisation';
import { IdentityProvider } from '../models/IdentityProvider';
import { getSettings } from '../Settings';

export const useLoginRequest = () => {
  const organisation = useOrganisationContext();

  if (organisation) {
    if (organisation.identityProvider === IdentityProvider.SwedishBankID) {
      loginRequest.authority = getSettings().AUTHORITY_BANKID;
    }

    sessionStorage.setItem('slug', organisation.slug);
    loginRequest.state = organisation.id;
  }

  return { loginRequest };
};